import Vue from 'vue';
import Router from 'vue-router';
import WebView from "./pages/webview";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'scanbylocation',
      component: WebView,
      props: {url: process.env.VUE_APP_SCAN_BY_LOCATION_URL}
    },
    {
      path: '/scandetails',
      name: 'scandetails',
      component: WebView,
      props: {url: process.env.VUE_APP_SCAN_DETAILS_URL}
    },
    {
      path: '/imagesearch',
      name: 'imagesearch',
      component: () => import('./pages/dfpdashboard.vue')
    },

  ],
  scrollBehavior() {
    return {x: 0, y: 0};
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.permissions)) {
    if (Vue.prototype.$auth.user.permissions.hasAny(to.meta.permissions)) {
      next();
    } else {
      next(from.path)
    }
  } else {
    next();
  }
});

export default router;
